import styled from "styled-components";

import { getFocusBorderElement, T_HEADER_small } from "../../../global.style";
import { IconButton } from "../../button";
import { CaretIcon, TableCaretIcon } from "../../icon";

export const MonthNavButton = styled(IconButton)`
    margin: 0 10px;
    visibility: hidden;
`;

export const StyledMonthYearSelector = styled.div<{
    $isMain?: boolean;
    $isCompact?: boolean;
    $isOnlyYearPicker?: boolean;
}>`
    ${getFocusBorderElement({ offset: 2, keyboardOnly: true })};

    position: relative;
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: ${props => props.$isOnlyYearPicker ? "170px" : "270px"};
    margin-bottom: 36px;

    ${props => props.$isMain && `
        text-transform: uppercase;
        font-weight: bold;
        ${MonthNavButton} {
            visibility: visible;
        }
    `}
    ${props => props.$isCompact && `
        width: unset;
        ${MonthNavButton} {
            margin: 0 3px;
        }
    `}
    :hover ${MonthNavButton} {
        visibility: visible;
    }
`;

export const MonthAndYearValue = styled.div`
    position: relative;
    color: ${props => props.theme.C_ACT_main};
    cursor: pointer;

    ${T_HEADER_small};

    :hover {
        color: ${props => props.theme.C_ACT_der};
    }
`;

export const CaretIconLeft = styled(CaretIcon)`
    transform: rotate(90deg);
`;

export const CaretIconRight = styled(CaretIcon)`
    transform: rotate(-90deg);
`;

export const TableCaretIconLeft = styled(TableCaretIcon)`
    transform: rotate(90deg);
`;

export const TableCaretIconRight = styled(TableCaretIcon)`
    transform: rotate(-90deg);
`;